import axios from 'axios';
import { setupCache } from 'axios-cache-adapter';

const cache = setupCache({
  readHeaders: true,
  maxAge: 15 * 60 * 1000,
  limit: 1000,
  exclude: {
    query: false,
  },
});

export const createHttp = (isSSR, apiConfig) => {
  return axios.create({
    headers: {
      'Cache-Control': 'no-cache',
      ...('headers' in apiConfig ? apiConfig.headers : {}),
    },
    adapter: isSSR ? cache.adapter : undefined,
    ...apiConfig,
  });
};



// WEBPACK FOOTER //
// ./src/remote/index.js